export default __webpack_public_path__ + "static/media/search-result.35ee13b9.jpg";